<template>
  <div class="home">
    <TimelineGallery/>
  </div>
</template>

<script>
// @ is an alias to /src
import TimelineGallery from '@/components/TimelineGallery.vue';
import _ from 'lodash';

export default {
  name: 'home',

  data: function () {
    return {
    }
  },  
    
  components: {
    TimelineGallery
  }
}
</script>

<style lang="scss">
  html,
  body {
    overflow: hidden;
  }

  body {
    margin: 0;
    &::-webkit-scrollbar { 
      display: none;
      width: 0 !important; 
    }
  }
</style>